// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
import type { IconComponent, IconName } from "./icon-types";
import AlertsIcon from "./generated/alerts";
import ArrowLeftShrinkSidebarIcon from "./generated/arrow-left-shrink-sidebar";
import ArrowLeftIcon from "./generated/arrow-left";
import ArrowRightExpandSidebarIcon from "./generated/arrow-right-expand-sidebar";
import ArrowUpRightIcon from "./generated/arrow-up-right";
import AssetIcon from "./generated/asset";
import BinocularsIcon from "./generated/binoculars";
import ButtonLoadSpinnerIcon from "./generated/button-load-spinner";
import CalendarIcon from "./generated/calendar";
import ChartLineIcon from "./generated/chart-line";
import CheckMarkIcon from "./generated/check-mark";
import ChecklistIcon from "./generated/checklist";
import ChevronDownIcon from "./generated/chevron-down";
import ChevronLeftIcon from "./generated/chevron-left";
import ChevronRightIcon from "./generated/chevron-right";
import ChevronUpIcon from "./generated/chevron-up";
import CircleCheckIcon from "./generated/circle-check";
import CircleExclamationIcon from "./generated/circle-exclamation";
import CircleInfoIcon from "./generated/circle-info";
import ClockSevenIcon from "./generated/clock-seven";
import CustomersIcon from "./generated/customers";
import DocumentIcon from "./generated/document";
import EllipsisDotsHorizIcon from "./generated/ellipsis-dots-horiz";
import EllipsisDotsIcon from "./generated/ellipsis-dots";
import ErrorSolidIcon from "./generated/error-solid";
import ErrorIcon from "./generated/error";
import EyeWatchingIcon from "./generated/eye-watching";
import FacilitiesIcon from "./generated/facilities";
import FilterIcon from "./generated/filter";
import HardwareIcon from "./generated/hardware";
import HomeIcon from "./generated/home";
import ImageRegularIcon from "./generated/image-regular";
import IntegrationsIcon from "./generated/integrations";
import ListIcon from "./generated/list";
import LocationPinSolidIcon from "./generated/location-pin-solid";
import MaintenanceIcon from "./generated/maintenance";
import MenuHamburgerIcon from "./generated/menu-hamburger";
import MonitoringPointIcon from "./generated/monitoring-point";
import NotificationBellIcon from "./generated/notification-bell";
import OilAnalysisBottleIcon from "./generated/oil-analysis-bottle";
import PlusRegularIcon from "./generated/plus-regular";
import PriorityIcon from "./generated/priority";
import SearchIcon from "./generated/search";
import SettingsCogIcon from "./generated/settings-cog";
import SortIcon from "./generated/sort";
import SparklesIcon from "./generated/sparkles";
import StarRecommendedIcon from "./generated/star-recommended";
import TrendDownIcon from "./generated/trend-down";
import TrendNoChangeIcon from "./generated/trend-no-change";
import TrendUpIcon from "./generated/trend-up";
import UploadIcon from "./generated/upload";
import UserIcon from "./generated/user";
import WarningIcon from "./generated/warning";
import WorkorderIcon from "./generated/workorder";
import XCloseIcon from "./generated/x-close";

export const coreIconRegistry = {
  "alerts": AlertsIcon,
  "arrow-left-shrink-sidebar": ArrowLeftShrinkSidebarIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-right-expand-sidebar": ArrowRightExpandSidebarIcon,
  "arrow-up-right": ArrowUpRightIcon,
  "asset": AssetIcon,
  "binoculars": BinocularsIcon,
  "button-load-spinner": ButtonLoadSpinnerIcon,
  "calendar": CalendarIcon,
  "chart-line": ChartLineIcon,
  "check-mark": CheckMarkIcon,
  "checklist": ChecklistIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  "circle-check": CircleCheckIcon,
  "circle-exclamation": CircleExclamationIcon,
  "circle-info": CircleInfoIcon,
  "clock-seven": ClockSevenIcon,
  "customers": CustomersIcon,
  "document": DocumentIcon,
  "ellipsis-dots-horiz": EllipsisDotsHorizIcon,
  "ellipsis-dots": EllipsisDotsIcon,
  "error-solid": ErrorSolidIcon,
  "error": ErrorIcon,
  "eye-watching": EyeWatchingIcon,
  "facilities": FacilitiesIcon,
  "filter": FilterIcon,
  "hardware": HardwareIcon,
  "home": HomeIcon,
  "image-regular": ImageRegularIcon,
  "integrations": IntegrationsIcon,
  "list": ListIcon,
  "location-pin-solid": LocationPinSolidIcon,
  "maintenance": MaintenanceIcon,
  "menu-hamburger": MenuHamburgerIcon,
  "monitoring-point": MonitoringPointIcon,
  "notification-bell": NotificationBellIcon,
  "oil-analysis-bottle": OilAnalysisBottleIcon,
  "plus-regular": PlusRegularIcon,
  "priority": PriorityIcon,
  "search": SearchIcon,
  "settings-cog": SettingsCogIcon,
  "sort": SortIcon,
  "sparkles": SparklesIcon,
  "star-recommended": StarRecommendedIcon,
  "trend-down": TrendDownIcon,
  "trend-no-change": TrendNoChangeIcon,
  "trend-up": TrendUpIcon,
  "upload": UploadIcon,
  "user": UserIcon,
  "warning": WarningIcon,
  "workorder": WorkorderIcon,
  "x-close": XCloseIcon,
} satisfies Partial<Record<IconName, IconComponent>>;